import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';

export interface PrimitiveButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ref?: Ref<HTMLButtonElement>;
}

export function PrimitiveButton(props: PrimitiveButtonProps): ReactNode {
  const { type = 'button', ...rest } = props;
  return <button type={type} {...rest} data-component="PrimitiveButton" />;
}
